const PROFILE_PRESETS = {
    saas: { API_URL: 'https://demo-api.safedb.biz', AUTH_URL: 'https://auth-api.safedb.biz', isK8s: false },
    k8s: { API_URL: 'https://api.safedb.biz', AUTH_URL: 'https://auth.safedb.biz', isK8s: true },
    local: { API_URL: 'http://localhost:20000', AUTH_URL: 'http://localhost:21000', isK8s: false }
};

export const getConfig = () => {
    // 런타임에 설정된 환경변수 (운영환경: entrypoint.sh에서 설정)
    const rt = window.__APP_CONFIG__ || {};

    // 빌드타임 환경변수 (개발환경: .env 파일에서 설정)
    const bt = {
        API_URL: process.env.REACT_APP_API_URL,
        AUTH_URL: process.env.REACT_APP_AUTH_URL,
        PROFILE: process.env.REACT_APP_PROFILE,
        IS_K8S: process.env.REACT_APP_IS_K8S,
        DEMO: process.env.REACT_APP_DEMO,
        // SSO (Keycloak) 관련 빌드타임 환경변수
        SSO_ENABLED: process.env.REACT_APP_SSO_ENABLED,
        SSO_KEYCLOAK_URL: process.env.REACT_APP_SSO_KEYCLOAK_URL,
        SSO_REALM: process.env.REACT_APP_SSO_REALM,
        SSO_CLIENT_ID: process.env.REACT_APP_SSO_CLIENT_ID
    };

    // 1) 우선 PROFILE 결정
    const profile = rt.PROFILE || bt.PROFILE || 'local';

    // 2) PROFILE에서 기본 URL 가져오기
    const preset = PROFILE_PRESETS[profile] || PROFILE_PRESETS.local;

    // 3) k8s 여부 결정 (local의 경우 환경변수로 override 가능)
    let isK8s = preset.isK8s;
    if (profile === 'local') {
        // local의 경우 환경변수로 k8s 여부를 명시적으로 설정할 수 있음
        if (rt.IS_K8S !== undefined) {
            isK8s = rt.IS_K8S === 'true' || rt.IS_K8S === true;
        } else if (bt.IS_K8S !== undefined) {
            isK8s = bt.IS_K8S === 'true' || bt.IS_K8S === true;
        }
    }

    // 4) 최종 URL 결정 - local인 경우 항상 localhost 사용
    let finalApiUrl, finalAuthUrl;

    if (profile === 'local') {
        // local 환경: 빌드타임(.env) 우선 → 런타임(config.js) → 프리셋 순 fallback
        // npm run start: .env가 있으므로 빌드타임 값 사용 (기존 동작 유지)
        // Docker: .dockerignore로 .env 제외 → 빌드타임 없음 → 런타임(entrypoint.sh) 값 사용
        finalApiUrl = bt.API_URL || rt.API_URL || preset.API_URL;
        finalAuthUrl = bt.AUTH_URL || rt.AUTH_URL || preset.AUTH_URL;
    } else {
        // 비-local 환경: 런타임 우선 → 빌드타임 → 프리셋
        finalApiUrl = rt.API_URL || bt.API_URL || preset.API_URL;
        finalAuthUrl = rt.AUTH_URL || bt.AUTH_URL || preset.AUTH_URL;
    }

    // 5) SSO(Keycloak) 설정 값 결정
    // 요구사항: profile === 'local' 일 때는 빌드타임(.env) 우선, 그 외에는 런타임(config.js) 우선
    let finalSsoEnabled, finalSsoKeycloakUrl, finalSsoRealm, finalSsoClientId;
    if (profile === 'local') {
        finalSsoEnabled = (bt.SSO_ENABLED ?? rt.SSO_ENABLED ?? 'false');
        finalSsoKeycloakUrl = bt.SSO_KEYCLOAK_URL || rt.SSO_KEYCLOAK_URL || 'http://localhost:8080';
        finalSsoRealm = bt.SSO_REALM || rt.SSO_REALM || 'safedb';
        finalSsoClientId = bt.SSO_CLIENT_ID || rt.SSO_CLIENT_ID || 'safedb-frontend';
    } else {
        finalSsoEnabled = (rt.SSO_ENABLED ?? bt.SSO_ENABLED ?? 'false');
        finalSsoKeycloakUrl = rt.SSO_KEYCLOAK_URL || bt.SSO_KEYCLOAK_URL;
        finalSsoRealm = rt.SSO_REALM || bt.SSO_REALM;
        finalSsoClientId = rt.SSO_CLIENT_ID || bt.SSO_CLIENT_ID;
    }

    const isDemo = String(rt.DEMO || bt.DEMO || 'false') === 'true';

    const config = {
        PROFILE: profile,
        API_URL: finalApiUrl,
        AUTH_URL: finalAuthUrl,
        IS_K8S: isK8s,
        DEMO: isDemo,
        // SSO (Keycloak)
        SSO_ENABLED: String(finalSsoEnabled) === 'true',
        SSO_KEYCLOAK_URL: finalSsoKeycloakUrl,
        SSO_REALM: finalSsoRealm,
        SSO_CLIENT_ID: finalSsoClientId,
    };

    // 개발 환경에서 디버깅을 위한 로그
    if (process.env.NODE_ENV === 'development') {
        console.log('🔧 Config Debug:', {
            'profile': profile,
            'isK8s': isK8s,
            'runtime': rt,
            'buildtime': bt,
            'preset': preset,
            'final': config
        });
    }

    return config;
};
